import React, {useRef} from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';

import {Button, Dialog, DialogHeader, DialogBody, DialogFooter} from '@stubhub/bamboo';

import './ImportantInfoModal.scss';

const ImportantInfoModal = ({header, message, onClose}) => {
  const headerRef = useRef(null);

  return (
    <Dialog
      className="important-information-modal"
      id="important-information-modal"
      isOpen
      size="lg"
      closeOnEsc={false}
      closeOnOverlayClick={false}
      initialFocusRef={headerRef}
      onDismiss={onClose}
    >
      <DialogHeader className="important-information-modal__header" ref={headerRef} tabIndex={-1}>
        {header}
      </DialogHeader>
      <DialogBody>
        {/* eslint-disable-next-line react/no-danger */}
        <div className="important-information-modal__content" dangerouslySetInnerHTML={{__html: message}} />
      </DialogBody>
      <DialogFooter>
        <Button className="important-information-modal__button" kind="primary" onClick={onClose}>
          <FormattedMessage id="ImportantInfoModal.button" defaultMessage="OK, got it" />
        </Button>
      </DialogFooter>
    </Dialog>
  );
};

ImportantInfoModal.propTypes = {
  header: PropTypes.string.isRequired,
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  onClose: PropTypes.func,
};

export default ImportantInfoModal;
